import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { ICompany } from 'src/app/interfaces/company';
import { IBranch } from 'src/app/interfaces/branch';
import { MatSelectChange, MatSelect } from '@angular/material';
//import { RegistrationReportService } from 'src/app/services/http/business/report/registration-report.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ITermInfo } from 'src/app/interfaces/term-info';
import { TermInfoService } from 'src/app/services/http/business/term-info/term-info.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import * as moment from "jalali-moment";
import { CoursePatternService } from 'src/app/services/http/business/course-pattern/course-pattern.service';
import { ServiceRoute } from 'src/app/services/http/base/service-route';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ParrentTermService } from 'src/app/services/http/business/parrent-term/parrent-term-service.service';
import { CouponService } from 'src/app/services/http/business/coupon/coupon.service';
import { HttpHeaders } from '@angular/common/http';
import { ICalendar } from 'src/app/interfaces/calendar';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { CourseTypeService } from 'src/app/services/http/business/course-type/course-type.service';


@Component({
  selector: 'app-financial-report',
  templateUrl: './financial-report.component.html',
  styleUrls: ['./financial-report.component.css']
})
export class FinancialReportComponent implements OnInit {

  param: any;
  errObject: any;
  errors = new Array();
  form: FormGroup;
  isOwner: boolean;
  compnayList: ICompany;
  branchList: IBranch[];
  reportUrl: string;
  iframe: any;
  termList: ITermInfo[];
  TermInfo: number;
  startDateModel: string;
  endDateModel: string;
  levelInfoList: ILevelInfo[];
  coursPatterns: any;
  parrentTermList: any; //IParentTerm[];
  yearList: ICalendar;
  userName: string;
  eduPackageList: IEducationPackage;
  couponCategory = [];
  token = localStorage.getItem("token");
  reports = [
    { id: 1, title: 'لیست دریافتی ها از تعیین سطح' },
    { id: 2, title: 'لیست دریافتی ها از ثبت نام' },
    { id: 3, title: 'لیست ثبت نام های استرداد شده' },
    { id: 4, title: 'لیست تعیین سطح های استرداد شده' },
    { id: 5, title: 'لیست دانشجویان تخفیفی', active: true },
    { id: 6, title: 'بن های استفاده شده', active: true },
    { id: 7, title: "لیست دریافتی از ثبت نام بر اساس ترم", active: true}
  ];

  showPackage = false;
  showLevel = false;
  showPattern = false;
  showTerm = false;
  showTime = false;
  showTermEffect = false;
  showNationalCode = false;
  showName = false;
  showcouponCategory = false;
  showYear: boolean;
  courseTypeList: any;

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private bidService: BIDService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private branchService: BranchService,
    private couponService: CouponService,
    public translate: TranslateService,
    private parrentTermService: ParrentTermService,
    private courseTypeService: CourseTypeService,
    private errorService: ErrorsService,
    private coursPatternService: CoursePatternService,
    // private registrationReportService: RegistrationReportService,
    private termService: TermInfoService,
    private sanitizer: DomSanitizer,
    private eduPackageService: EducationPackageService,
    private calendarService: CalendarService,
    private levelInfoService: LevelInfoService
  ) { }

  ngOnInit() {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(this.token);
    this.userName = decodedToken.fname;
    this.checkOwner();
    this.createForm();
    this.getCompanyList();
    this.loadYear();
    this.getEduPackage();
    this.getCouponCategory();
  }

  createForm() {
    this.form = this.fb.group({
      BranchEncryptId: [null],
      ReportId: [null, Validators.required],
      ParentTermId: [null],
      TermInfo: [null],
      StartDate: [null],
      EndDate: [null],
      TermEffect: [false],
      PackageId: [null],
      Year: [null],
      LevelInfoId: [null],
      CoursePatternId: [null],
      RegistrationStatusId: [null],
      NationalCode: [null],
      CouponCategoryId: [null],
      FirstName: [null],
      LastName: [null],
      StudentFullName: [null],
      CourseTypeId: [null]
    });
    if (this.isOwner) {
      this.form.setValue({
        BranchEncryptId: this.bidService.getBID()
      });
    }
  }

  getCouponCategory() {
    this.couponService.couponCategory().subscribe(res => {
      this.couponCategory = res;
    });
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCoursTypeList() {
    this.courseTypeService.list(0, 0, false, false, true).subscribe(
      res => {
        this.courseTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getParrentTermList(e: MatSelect) {
    this.parrentTermService.listComboByYear(e.value).subscribe(
      res => {
        this.parrentTermList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCoursPattern(e: MatSelect) {
    this.coursPatternService.getListByCourseTypeId(e.value, 0, 0).subscribe(res => {
      this.coursPatterns = res;
    },
      () => {
        this.errorService.transactionError();
      });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        this.bidService.setBID("");
      }
      else {
        this.loadCoursTypeList();
        //this.getParrentTermList();
        // this.termService.list(0, 0).subscribe(res => {
        //   this.termList = res.DataList;
        // });
      }
    });
  }


  laodLevel(element: MatSelectChange) {
    this.levelInfoService.getlistByEducationPackageId(element.value).subscribe(
      res => {
        this.levelInfoList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }


  setCid(e: MatSelectChange) {

    if (this.isOwner) {
      this.cidService.setCID(e.value);
      this.bidService.removeBID();
      this.loadCoursTypeList();
    }
    this.getBranchList(e.value);
    this.form.get('BranchEncryptId').setValue(null);
    //this.getParrentTermList();
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
    this.termService.list(0, 0).subscribe(res => {
      this.termList = res.DataList;
    });
  }

  setDate(e: MatSelect) {
    const parentTerm = this.parrentTermList.find(function (element) {
      return element.Id === e.value;
    });

    this.startDateModel = parentTerm.StartDate; //moment.from(year + '/' + parentTerm.MonthAndDayStart, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')
    this.endDateModel = parentTerm.EndDate; //moment.from(year + '/' + parentTerm.MonthAndDayEnd, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')

  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  setReport(e: MatSelectChange) {
    for (const key in this.form.controls) {
      if(key != 'ReportId')
      {
        this.form.get(key).clearValidators();
        this.form.get(key).updateValueAndValidity();
        this.form.get(key).reset();
      }
    }

    if(this.isOwner)
    {
      this.changeValidators('BranchEncryptId');
    }

    this.showPackage = false;
    this.showLevel = false;
    this.showPattern = false;
    this.showTerm = false;
    this.showTime = false;
    this.showNationalCode = false;
    this.showName = false;
    this.showTermEffect = false;
    this.showcouponCategory = false;
    switch (parseInt(e.value)) {
      case 1:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTime = true;
        break;
      case 2:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTime = true;
        this.showPackage = true;
        this.showLevel = true;
        this.showPattern = true;
        this.showTermEffect = true;
        break;
      case 3:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTime = true;
        // this.showPackage = true;
        // this.showLevel = true;
        // this.showPattern = true;
        break;
      case 4:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showTime = true;
        break;
      case 5:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showName = true;
        this.showNationalCode = true;
        this.showTime = true;
        break;
      case 6:
        this.changeValidators('StartDate');
        this.changeValidators('EndDate');
        this.showTime = true;
        this.showNationalCode = true;
        this.showcouponCategory = true;
        break;
      case 7:
        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.showTerm = true;
        this.showYear = true;
        this.showPackage = true;
        this.showLevel = true;
        this.showPattern = true;
        this.showTermEffect = true;
        break;
    }
  }

  changeValidators(key: string) {
    this.form.controls[key].setValidators(Validators.required);
    this.form.controls[key].updateValueAndValidity();
  }


  getBranchList(company) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  submit(data: any) {
    data.StartDate = moment
      .from(data.StartDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    data.EndDate = moment
      .from(data.EndDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    let url = '';
    switch (parseInt(data.ReportId)) {
      case 1:

        url = environment.ReportBaseUrl + ServiceRoute.report.financial.GetPlacmectPaymentShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&ParentTermId=' + data.ParentTermId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 2:
        url = environment.ReportBaseUrl + ServiceRoute.report.financial.GetRegistrationPaymentShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&ParentTermId=' + data.ParentTermId +
          '&UserName=' + this.userName +
          '&Packageid=' + data.PackageId +
          '&TermEffect= ' + data.TermEffect +
          '&LevelInfoId=' + data.LevelInfoId +
          '&coursePatternId=' + data.CoursePatternId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 3:
        url = environment.ReportBaseUrl + ServiceRoute.report.financial.GetRejectShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&ParentTermId=' + data.ParentTermId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
        case 4:
        url = environment.ReportBaseUrl + ServiceRoute.report.financial.GetPlacementRejectShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&ParentTermId=' + data.ParentTermId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 5:
        url = environment.ReportBaseUrl + ServiceRoute.report.education.GetDiscountRegistrationShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&NationalCode=' + data.NationalCode +
          '&FirstName=' + data.FirstName +
          '&LastName=' + data.LastName +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 6:
        url = environment.ReportBaseUrl + ServiceRoute.report.financial.GetUsedCouponsShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&UserName=' + this.userName +
          '&CouponCategoryId=' + data.CouponCategoryId +
          '&NationalCode=' + data.NationalCode +
          '&StartDate=' + data.StartDate +
          '&EndDate=' + data.EndDate +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 7:
        url = environment.ReportBaseUrl + ServiceRoute.report.financial.GetRegistrationPaymentIgnoreDateShow +
        '?CompanyId=' + this.cidService.getCID() +
        '&ParentTermId=' + data.ParentTermId +
        '&UserName=' + this.userName +
        '&Packageid=' + data.PackageId +
        '&TermEffect= ' + data.TermEffect +
        '&LevelInfoId=' + data.LevelInfoId +
        '&coursePatternId=' + data.CoursePatternId +
        '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
    }
    this.iframe = this.sanitizer.bypassSecurityTrustResourceUrl(url.split("null").join(""));
  }
}

